/**
 * SidebarAccount — Avatar-Menü + Anzeigename am unteren Ende der Sidebar.
 * Redesign S2 (2026-10-10): die Glocke ist zurück in die Topbar gewandert
 * (`NotificationsBell`), hier bleibt nur der Account. Heller Sidebar-Grund →
 * Avatar als grüner Kreis, Name daneben (collapsed: nur der Kreis).
 *
 * Positionierung: von der Sidebar AUSSERHALB ihres overflow-y-auto-Scroll-
 * Wrappers gerendert (im overflow-visible <aside>), damit das AvatarMenu
 * (öffnet nach oben, placement="top-left") nicht geclippt wird.
 */
import { AvatarMenu } from './AvatarMenu';
import { startTour } from '../lib/onboarding-tour';

type Props = {
  user: { displayName: string };
  onLogout: () => void;
  /** Icon-Rail-Modus (≥md): nur der Avatar, ohne Namen. */
  collapsed: boolean;
};

const AVATAR_TRIGGER_CLASS =
  'w-9 h-9 rounded-full bg-brand-green-700 text-white flex items-center justify-center text-xs font-semibold hover:bg-brand-green-800 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green-500 focus-visible:ring-offset-2';

export function SidebarAccount({ user, onLogout, collapsed }: Props) {
  return (
    <div
      className={`flex items-center gap-2.5 border-t border-ink-100 px-4 py-3 ${
        collapsed ? 'md:justify-center md:px-0' : ''
      }`}
    >
      <AvatarMenu
        user={{ displayName: user.displayName }}
        onLogout={onLogout}
        // `startTour()` liefert false, wenn kein Anker im DOM steht — dann
        // passiert schlicht nichts. Kein Toast: das Menü schliesst ohnehin.
        onStartTour={() => {
          startTour();
        }}
        placement="top-left"
        triggerClassName={AVATAR_TRIGGER_CLASS}
      />
      <span
        className={`min-w-0 truncate text-xs font-semibold text-ink-900 ${
          collapsed ? 'md:hidden' : ''
        }`}
      >
        {user.displayName}
      </span>
    </div>
  );
}
